import React from "react";
import { observer } from "mobx-react";
import { useStore } from "store";
import { cn } from "helpers/style";
import { capitalize } from "helpers/text";
import styles from "./DeliveryBlock.module.scss";

type Props = {
  product: Entity.Product;
  horizontal?: boolean;
  className?: string;
};

const DeliveryBlock: React.FC<Props> = ({
  product,
  horizontal,
  className,
}: Props) => {
  const { user } = useStore();

  const deliveryBlockText = () => {
    const res = [
      product.deliveryDate && "доставка",
      product.pickupDate && "самовывоз",
      user.profile?.isOperator && product.availableForBooking && "бронирование",
    ].filter(el => el);

    const text = res.reduce((acc, deliveryType, index) => {
      if (index === res.length - 1 && res.length > 1) {
        return (acc += " и " + deliveryType);
      }
      if (index === 0) {
        return deliveryType;
      }
      return (acc += ", " + deliveryType);
    }, "");

    return capitalize(text);
  };

  if (
    !product.deliveryDate &&
    !product.pickupDate &&
    !product.availableForBooking
  )
    return null;

  return (
    <div
      className={cn([
        styles.deliveryBlock,
        horizontal && styles.deliveryBlockHorizontal,
        className,
      ])}
    >
      {deliveryBlockText()}
    </div>
  );
};

export default observer(DeliveryBlock);
